import React, { useMemo } from "react";
// eslint-disable-next-line
import { $, gettext } from "../../adapter";
import { useSelector } from "react-redux";
import { parseRegion } from "../../utils/weatherForecastUtils";

const Radar = () => {
  const regionState = useSelector((state) => {
    return state.weatherRegion;
  });

  const { region } = useMemo(() => {
    if (!regionState.region) {
      return { ...regionState };
    } else {
      return {
        ...parseRegion(regionState.region),
      };
    }
  }, [regionState]);

  if (!region) return null;

  var imagename = "";
  var image = null;
  var europe = false;
  if (region.country === "NL") {
    image = "radarNgr.gif";
    imagename = "Nederland";
    europe = true;
  }
  if (region.country === "F" || region.country === "B") {
    europe = true;
  }
  if (region.country === "UK" || region.country === "IRL") {
    europe = true;
  }
  if (region.country === "D" || region.country === "CH") {
    europe = true;
  }
  if (image) {
    image = "https://www.dacom.nl/api/radar/" + image;
    return (
      <div>
        <div className="l-half js-equalize">
          <div className="panel">
            <h2 className="little-spacing">
              {gettext("Precipitation")}: <small>{imagename}</small>
            </h2>
            <img alt="Zoom" id="zoom_gif" data-zoom-image={image} src={image} />
          </div>
        </div>
        <div className="l-half js-equalize">
          <div className="panel">
            <h2 className="little-spacing">
              {gettext("Precipitation")}: <small>{gettext("Europe")}</small>
            </h2>
            <img
              alt="Radar"
              id="zoom_eur"
              data-zoom-image="https://www.dacom.nl/api/radar/radarE.gif"
              src="https://www.dacom.nl/api/radar/radarE.gif"
            />
          </div>
        </div>
      </div>
    );
  } else if (europe) {
    return (
      <div className="l-full js-equalize">
        <div className="panel">
          <h2 className="little-spacing">
            {gettext("Precipitation")}: <small>{gettext("Europe")}</small>
          </h2>
          <img
            alt="Radar"
            id="zoom_eur"
            data-zoom-image="https://www.dacom.nl/api/radar/radarE.gif"
            src="https://www.dacom.nl/api/radar/radarE.gif"
          />
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default Radar;
